import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const styles = {
	modalContentBase: {
		flex: 1,
		'@media (min-height: 30rem)': {
			overflowY: 'auto',
			overflowX: 'hidden'
		}
	},
	modalContentDefault: {
		extend: 'modalContentBase',
		padding: '3.75rem',
		'@media (max-width: 575px)': {
			padding: '1.5rem 1rem 1rem'
		}
	},

	modalContentNoPadding: {
		extend: 'modalContentBase'
	}
}

const useStyles = createUseStyles(styles, { name: 'Vb' })

const ModalContent = forwardRef(function ModalContent(props, ref) {
	const { children, noPadding, ...other } = props

	const classes = useStyles()

	return (
		<div ref={ref} className={noPadding ? classes.modalContentNoPadding : classes.modalContentDefault} {...other}>
			{children}
		</div>
	)
})

export default ModalContent

ModalContent.propTypes = {
	/**
	 * If `true`, the component has 0 padding.
	 * @default false
	 */
	noPadding: PropTypes.bool,

	/**
	 * Modal header children, usually its title.
	 */
	children: PropTypes.node
}
